


























































































































import { Component, Prop, Vue } from "vue-property-decorator";
import SlidingPanel from '../_sliding-panel/sliding-panel.vue';
import {
    NowInfinityLogo,
    CloudoffisLogo
} from '../../assets/icons';
import { SidebarState } from '../../store';
import { IIntegrationConfig } from '../../store/SidebarState/types';
import { namespace } from 'vuex-class';
import DapLogo from "@/components/04-web-components/powerbar/assets/icons/DapLogo.vue";
import MyProsperityLogo from "@/components/04-web-components/powerbar/assets/icons/MyProsperityLogo.vue";
import VmrLogo from "@/components/04-web-components/powerbar/assets/icons/VmrLogo.vue";
const sidebarState = namespace('SidebarState');

@Component({
    name: "AxSidebar",
    components: {
      DapLogo,
        SlidingPanel,
        NowInfinityLogo,
        CloudoffisLogo,
        MyProsperityLogo,
        VmrLogo
    },
})
export default class AxSidebar extends Vue {
    @Prop({ required: false }) public integrationConfig: IIntegrationConfig;
    @Prop({ required: false }) public enableDapSso: string;

    @sidebarState.Getter isSidebarOpen: boolean;
    @sidebarState.Action closeSidebar: () => void;
    @sidebarState.Action toggleSidebar: () => void;


    public get cloudOffisEnabled() {
        return this.integrationConfig?.cloudoffis?.enabled;
    }

    public get cloudOffisUrl() {
        return this.integrationConfig?.cloudoffis?.url;
    }

    public get myProsperityEnabled() {
        return this.integrationConfig?.myProsperity?.enabled;
    }

    public get myProsperityUrl() {
        return this.integrationConfig?.myProsperity?.url;
    }
    public get virtualMainRoomEnabled() {
        return this.integrationConfig?.virtualMailRoom?.enabled;
    }

    public get virtualMainRoomUrl() {
        return this.integrationConfig?.virtualMailRoom?.url;
    }
    public onClickOutside(e: Event) {
        const targetRefAxSideBar = (this.$refs.axSidebar as Vue).$el as HTMLElement;
        // const targetRefAxSideBar = this.$refs.axSidebar as HTMLElement;
        const eventTarget = e.target as HTMLElement;
        if (
            !(
                targetRefAxSideBar?.contains(eventTarget) ||
                eventTarget?.shadowRoot?.contains(targetRefAxSideBar)
            )
        ) {
            this.closeSidebar();
        }
    }


    public mounted() { window.addEventListener('scroll', this.closeSidebar); }
    public unmounted() { window.removeEventListener('scroll', this.closeSidebar); }

    public beforeCreate() { SidebarState.register?.(this.$store); }
    public destroyed() { SidebarState.unregister?.(this.$store); }
}
